import { createSlice } from '@reduxjs/toolkit';
const initialState = [];
const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        getTasks(state, action) {
            return action.payload;
        },
        createTask(state, action) {
            const newState = [...state, action.payload];
            return newState.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        },
        deleteTasks(state, action) {
            const taskId = action.payload;
            return state.filter((task) => task._id !== taskId);
        },
        updateStatus(state, action) {
            const { id, status } = action.payload;
            return state.map((task) => (task._id === id ? Object.assign(Object.assign({}, task), { status }) : task));
        },
        updateCategory(state, action) {
            const { id, category } = action.payload;
            return state.map((task) => (task._id === id ? Object.assign(Object.assign({}, task), { category }) : task));
        },
        isComplete(state, action) {
            const taskId = action.payload;
            return state.map((task) => (task._id === taskId ? Object.assign(Object.assign({}, task), { status: 'Done' }) : task));
        },
        restoreTask(state, action) {
            return [...state, action.payload];
        },
        resetTasks() {
            return [];
        },
        updateTaskOrder(state, action) {
            return action.payload;
        },
    },
});
export const { getTasks, deleteTasks, updateStatus, isComplete, createTask, restoreTask, resetTasks, updateTaskOrder, updateCategory, } = tasksSlice.actions;
export default tasksSlice.reducer;
